<template>
  <div class="coro-filter-content">
    <cui-filter-wrapper
      :show-clear-button="showClearFiltersButton"
      @clear-filters-clicked="clearFilters()"
    >
      <v-text-field
        v-model="domainsFilters.search"
        :class="{ 'filter-active': domainsFilters.search?.length }"
        density="compact"
        variant="outlined"
        :placeholder="$t('reports.dnsSummaryReport.domains.searchDomains')"
        :aria-label="$t('reports.dnsSummaryReport.domains.searchDomains')"
        class="search-field mr-1"
        prepend-inner-icon="icon-search-xs"
        clearable
        rounded
        clear-icon="icon-close-xs"
        @click:clear="domainsFilters.search = ''"
      />
      <v-select
        v-model="domainsFilters.status"
        :items="domainStatusOptions"
        bg-color="white"
        menu-icon="icon-arrow-down-xs"
        :menu-props="{ maxHeight: '300' }"
        class="types-filter filter-menu mr-1"
        :class="{ 'filter-active': domainsFilters.status }"
        :placeholder="$t('reports.dnsSummaryReport.domains.allStatuses')"
        data-testid="domains-table-status-filter"
        density="compact"
        variant="outlined"
        rounded
        hide-details
        background-color="white"
      >
        <template #selection="{ item, index }">
          <span v-if="index === 0" class="body2">{{
            $t(`reports.dnsSummaryReport.domains.${item.title}`)
          }}</span>
        </template>
        <template #item="{ item, props }">
          <v-list-item v-bind="props" title="">
            <v-list-item-title :data-testid="`domains-table-status-filter-${item}-item`" title="">
              {{ $t(`reports.dnsSummaryReport.domains.${item.title}`) }}
            </v-list-item-title>
          </v-list-item>
        </template>
      </v-select>
      <v-select
        v-model="domainsFilters.devices"
        :items="filteredDevices"
        bg-color="white"
        menu-icon="icon-arrow-down-xs"
        :menu-props="{ maxHeight: '300' }"
        class="types-filter filter-menu mr-1"
        :class="{ 'filter-active': domainsFilters.devices?.length }"
        :placeholder="$t('reports.dnsSummaryReport.domains.allDevices')"
        data-testid="domains-table-devices-filter"
        density="compact"
        variant="outlined"
        multiple
        rounded
        hide-details
        background-color="white"
        @close="devicesSearch = ''"
      >
        <template #prepend-item>
          <v-list-item class="pa-0">
            <v-text-field
              v-model="devicesSearch"
              class="mx-2 my-2 filter-search-field"
              bg-color="indigo-faint"
              variant="solo"
              density="compact"
              rounded="pill"
              clear-icon="$x"
              :placeholder="$t('general.search')"
              :aria-label="$t('general.search')"
              prepend-inner-icon="$search"
              @click:clear="devicesSearch = ''"
              clearable
              @keydown.space="$event.stopPropagation()"
              @mousedown="$event.stopPropagation()"
              hide-details
              flat
            >
            </v-text-field>
          </v-list-item>
        </template>
        <template #selection="{ index }">
          <span v-if="index === 0" class="body2 filter-item-preview">{{
            domainsFilters.devices[0]
          }}</span>
        </template>
        <template #label>
          <span v-if="domainsFilters.devices?.length" class="filter-label">
            {{ domainsFilters.devices.length }}
          </span>
        </template>
        <template #item="{ item, props }">
          <v-list-item v-bind="props" title="">
            <template v-slot:prepend="{ isActive }">
              <v-list-item-action start>
                <v-checkbox-btn density="compact" :model-value="isActive"></v-checkbox-btn>
              </v-list-item-action>
            </template>

            <v-list-item-title title="">
              {{ item.title }}
            </v-list-item-title>
          </v-list-item>
        </template>
      </v-select>
      <v-select
        v-model="domainsFilters.users"
        :items="filteredUsers"
        bg-color="white"
        menu-icon="icon-arrow-down-xs"
        :menu-props="{ maxHeight: '300' }"
        class="types-filter filter-menu"
        :class="{ 'filter-active': domainsFilters.users?.length }"
        :placeholder="$t('reports.dnsSummaryReport.domains.allUsers')"
        data-testid="domains-table-users-filter"
        density="compact"
        variant="outlined"
        multiple
        rounded
        hide-details
        background-color="white"
        @close="usersSearch = ''"
      >
        <template #prepend-item>
          <v-list-item class="pa-0">
            <v-text-field
              v-model="usersSearch"
              class="mx-2 my-2 filter-search-field"
              bg-color="indigo-faint"
              variant="solo"
              density="compact"
              rounded="pill"
              clear-icon="$x"
              :placeholder="$t('general.search')"
              :aria-label="$t('general.search')"
              prepend-inner-icon="$search"
              @click:clear="usersSearch = ''"
              clearable
              @keydown.space="$event.stopPropagation()"
              @mousedown="$event.stopPropagation()"
              hide-details
              flat
            >
            </v-text-field>
          </v-list-item>
        </template>
        <template #selection="{ index }">
          <span v-if="index === 0" class="body2 filter-item-preview">{{
            domainsFilters.users[0]
          }}</span>
        </template>
        <template #label>
          <span v-if="domainsFilters.users.length" class="filter-label">
            {{ domainsFilters.users.length }}
          </span>
        </template>
        <template #item="{ item, props }">
          <v-list-item v-bind="props" title="">
            <template v-slot:prepend="{ isActive }">
              <v-list-item-action start>
                <v-checkbox-btn density="compact" :model-value="isActive"></v-checkbox-btn>
              </v-list-item-action>
            </template>

            <v-list-item-title title="">
              {{ item.title }}
            </v-list-item-title>
          </v-list-item>
        </template>
      </v-select>
    </cui-filter-wrapper>
  </div>

  <v-data-table-server
    id="report-table"
    class="coronet-table--highlitable body2"
    item-key="id"
    show-expand
    expand-icon="icon-chevron-down-xs"
    :class="{ 'asc-sort': isAsc }"
    :items="dnsSummaryReport?.domainsList.items"
    :items-per-page="domainsPagination.pageSize"
    :items-length="dnsSummaryReport?.domainsList.total || 0"
    :page="domainsPagination.page + 1"
    :headers="headers"
    sort-asc-icon="$sortArrow"
    sort-desc-icon="$sortArrow"
    @update:options="
      handlePaginationChange({
        pageSize: $event.itemsPerPage,
        page: $event.page - 1,
        sortingOptions: $event.sortBy,
      })
    "
  >
    <template #item="{ item, isExpanded, internalItem, toggleExpand }">
      <tr :id="item.id" :key="item.id">
        <td class="w-5 expander-col">
          <v-icon
            class="ml-1"
            size="36"
            color="primary"
            :class="{ rotated: isExpanded(internalItem) }"
            @click="toggleExpand(internalItem)"
            icon="$chevronDown"
          >
          </v-icon>
        </td>
        <td class="subtitle2 w-30">{{ item.domain }}</td>
        <td>{{ item.details.length }}</td>
        <td>{{ item.hits }}</td>
        <td
          :class="{
            'text-red-dark': item.status === DnsDomainStatus.BLOCKED,
            'text-green-dark': item.status === DnsDomainStatus.ALLOWED,
          }"
        >
          {{ $t(`reports.dnsSummaryReport.domains.${item.status}`) }}
        </td>
      </tr>
    </template>

    <template #expanded-row="{ item }">
      <tr v-for="(user, index) in item.details" :key="`${user.user}-${index}`">
        <td class="w-5"></td>
        <td>{{ user.user || $t("reports.dnsSummaryReport.domains.none") }}</td>
        <td>{{ user.model || $t("reports.dnsSummaryReport.domains.none") }}</td>
        <td>{{ user.hits }}</td>
        <td></td>
      </tr>
    </template>
    <template #no-data>
      <div class="my-12 d-flex flex-column align-center">
        <v-icon class="mb-1" icon="$dataNoHexagon" size="80"></v-icon>
        <div class="headline6 mb-1">
          {{ $t("reports.dnsSummaryReport.domains.emptyTitle") }}
        </div>
        <div class="body-2 empty-data-state">
          {{ $t("reports.dnsSummaryReport.domains.emptyDescription") }}
        </div>
      </div>
    </template>
  </v-data-table-server>
</template>

<script lang="ts">
import { computed, defineComponent, ref, watch } from "vue";
import { FilterContext } from "@/_store/filters.module.ts";
import { CuiFilterWrapper } from "@coronet/cui";
import { DnsDomainStatus, DNS_REPORT_DEFAULT_PAGE_SIZE } from "@/constants/reports.ts";
import type { Pagination } from "@/types.ts";
import type { SortItem } from "@/_store/email-security/email-settings.module.ts";
import { useReportsStore } from "@/_store/reports.module.ts";
import { storeToRefs } from "pinia";
import { useI18n } from "vue-i18n";
import isEqual from "lodash/isEqual";
import { useFilters } from "@/composables/useFilters.ts";

export default defineComponent({
  components: {
    CuiFilterWrapper,
  },
  setup() {
    const i18n = useI18n();
    const reportsStore = useReportsStore();
    const { dnsSummaryReport, domainsPagination } = storeToRefs(reportsStore);

    const domainStatusOptions = Object.values(DnsDomainStatus);
    const {
      localFilters: domainsFilters,
      showClearFiltersButton,
      clearFilters,
    } = useFilters({
      context: FilterContext.DNS_REPORT_DOMAINS,
      searchKey: "search",
      onFilterChange: async () => {
        reportsStore.$patch({
          dnsSummaryReport: {
            domainsPagination: { page: 0, pageSize: DNS_REPORT_DEFAULT_PAGE_SIZE },
          },
        });
        await reportsStore.getDnsDomains();
      },
    });
    const devicesSearch = ref("");
    const usersSearch = ref("");
    const paginationSource = computed(() => ({
      page: domainsPagination.value.page,
      pageSize: domainsPagination.value.pageSize,
      sortingOptions: dnsSummaryReport?.value?.domainsSorting,
    }));
    const isAsc = computed(() => {
      const sorting = dnsSummaryReport?.value?.domainsSorting;
      return sorting && sorting.endsWith("asc");
    });

    watch(
      paginationSource,
      async (newOptions, oldOptions) => {
        if (!isEqual(newOptions, oldOptions)) {
          await reportsStore.getDnsDomains();
        }
      },
      {
        deep: true,
        immediate: false,
      }
    );

    const handlePaginationChange = async (
      pagination: Pagination & {
        sortingOptions: SortItem[];
      }
    ) => {
      reportsStore.$patch({
        dnsSummaryReport: {
          domainsPagination: { page: pagination.page, pageSize: pagination.pageSize },
          domainsSorting: pagination.sortingOptions[0]
            ? `${pagination.sortingOptions[0].key},${pagination.sortingOptions[0].order}`
            : undefined,
        },
      });
    };

    const filterListBySearch = (list?: string[], searchTerm: string = "") => {
      if (!list) return [];

      const trimmedSearchValue = searchTerm.trim().toLowerCase();
      if (!trimmedSearchValue) return list;

      return list.filter((item) => item.toLowerCase().includes(trimmedSearchValue));
    };

    const filteredDevices = computed(() => {
      return filterListBySearch(dnsSummaryReport?.value?.dnsDomainsDevices, devicesSearch.value);
    });

    const filteredUsers = computed(() => {
      return filterListBySearch(dnsSummaryReport?.value?.dnsDomainsUsers, usersSearch.value);
    });

    return {
      isAsc,
      domainsFilters,
      showClearFiltersButton,
      clearFilters,
      domainStatusOptions,
      handlePaginationChange,
      dnsSummaryReport,
      domainsPagination,
      DnsDomainStatus,
      devicesSearch,
      usersSearch,
      filteredDevices,
      filteredUsers,
      headers: [
        {
          title: "",
          key: "data-table-expand",
          sortable: false,
          headerProps: {
            "aria-label": i18n.t("ariaLabels.expanderColumn"),
          },
        },
        {
          title: i18n.t("reports.dnsSummaryReport.domains.name"),
          key: "domain",
        },
        {
          title: i18n.t("reports.dnsSummaryReport.domains.device"),
          key: "devices",
        },
        {
          title: i18n.t("reports.dnsSummaryReport.domains.hits"),
          key: "hits",
        },
        {
          title: i18n.t("reports.dnsSummaryReport.domains.status"),
          key: "status",
        },
      ],
    };
  },
});
</script>

<style scoped lang="scss">
.search-field {
  max-width: 280px;
}

:deep(*) {
  th {
    color: rgb(var(--v-theme-indigo-medium));
    font-size: 14px;
  }
}
:deep(.v-data-table__th--sorted) {
  .icon-sort-arrow-up {
    transform: none !important;
  }
}
:deep(.icon-data-no-hex-l:before) {
  color: rgb(var(--v-theme-indigo-light));
}

.filter-item-preview {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

#report-table:not(.asc-sort) :deep(.v-data-table__th--sorted) {
  .icon-sort-arrow-up {
    transform: rotate(180deg) !important;
  }
}

.types-filter {
  width: 150px;
}

.v-field__input {
  text-overflow: ellipsis;
}

.empty-data-state {
  max-width: 450px;
}

.filter-search-field {
  min-width: 200px;
  :deep(.v-field) {
    border-radius: 18px;
    padding: 6px;
    min-height: 36px;
    box-shadow: none;
  }

  :deep(.v-field__input) {
    padding: 0;
    min-height: 24px;
  }

  :deep(.v-field__prepend-inner) {
    padding-right: 8px;
  }

  :deep(.v-field__append-inner) {
    padding-left: 8px;
  }
}
</style>
